const numberFormat = (value: number) => {
  if (value === undefined) {
    return 0;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const BasicFormatter = {
  numberFormat,
};
